import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "./api";
import { Btn, ConfirmDialog } from "./atoms";

export default function BlogListPage() {
  const [posts, setPosts] = useState(null);
  const [confirmDel, setConfirmDel] = useState(null);
  const nav = useNavigate();

  const refresh = () => api.blogList().then(setPosts);
  useEffect(() => {
    refresh();
  }, []);

  const onCreate = async () => {
    const slug = `new-post-${Date.now().toString(36)}`;
    await api.blogCreate({ slug, title: "Untitled post" });
    nav(`/admin/blog/${slug}`);
  };
  const onDuplicate = async (slug) => {
    const dup = await api.blogDuplicate(slug);
    nav(`/admin/blog/${dup.slug}`);
  };
  const onDelete = async () => {
    await api.blogDelete(confirmDel.slug);
    setConfirmDel(null);
    refresh();
  };

  return (
    <div data-testid="admin-blog-list">
      <div className="flex items-center justify-between gap-4 mb-9">
        <div>
          <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">Blog</div>
          <h1 className="mt-3 font-display text-3xl font-black tracking-[-0.025em]">Posts</h1>
        </div>
        <Btn onClick={onCreate} data-testid="blog-new">＋ New post</Btn>
      </div>

      {posts === null ? (
        <div className="text-sm text-neutral-500">Loading…</div>
      ) : posts.length === 0 ? (
        <div className="text-sm text-neutral-500">No posts yet. Create your first one.</div>
      ) : (
        <ul className="divide-y divide-white/[0.06] border border-white/[0.06] rounded-xl overflow-hidden">
          {posts.map((p) => (
            <li
              key={p.slug}
              data-testid={`blog-row-${p.slug}`}
              className="flex items-center gap-5 px-5 py-4 bg-[#0F141A] hover:bg-[#13191F] transition-colors"
            >
              <span className="text-[0.65rem] font-bold tracking-[0.22em] uppercase text-[#F4D64E] tabular-nums shrink-0 w-10">
                {p.n || "—"}
              </span>
              <div className="flex-1 min-w-0">
                <Link
                  to={`/admin/blog/${p.slug}`}
                  className="font-bold text-white hover:text-[#F4D64E] transition-colors block truncate"
                  data-testid={`blog-edit-${p.slug}`}
                >
                  {p.title}
                </Link>
                <div className="text-[0.7rem] text-neutral-500 mt-1 truncate font-mono">/{p.slug}</div>
              </div>
              <span
                className={`text-[0.6rem] font-bold tracking-[0.22em] uppercase px-2 py-1 rounded ${
                  p.published
                    ? "bg-[#F4D64E]/15 text-[#F4D64E]"
                    : "bg-white/[0.05] text-neutral-500"
                }`}
              >
                {p.published ? "Live" : "Draft"}
              </span>
              {p.featured ? (
                <span className="text-[0.6rem] font-bold tracking-[0.22em] uppercase text-neutral-500">★ Featured</span>
              ) : null}
              <Btn variant="ghost" onClick={() => onDuplicate(p.slug)} data-testid={`blog-dup-${p.slug}`}>
                Duplicate
              </Btn>
              <Btn variant="danger" onClick={() => setConfirmDel(p)} data-testid={`blog-del-${p.slug}`}>
                Delete
              </Btn>
            </li>
          ))}
        </ul>
      )}

      <ConfirmDialog
        open={!!confirmDel}
        title="Delete this post?"
        message={`This will permanently remove "${confirmDel?.title}". Cannot be undone.`}
        onConfirm={onDelete}
        onCancel={() => setConfirmDel(null)}
        danger
      />
    </div>
  );
}
